import { useMemo, useState } from 'react';
import { ChevronDownIcon, CircleUserRoundIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { useIsMobile } from '@/hooks/use-mobile';
import { useAuth } from '@/lib/legacy';
import { CollateralModal as CollateralModalJs } from '../../pages/CollateralPage';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- boundary: pages/CollateralPage/CollateralPage.jsx
const CollateralModal = CollateralModalJs as any as (props: { open: boolean; onClose: () => void }) => JSX.Element;

/** The signed-in user's menu: Collateral, their Kalidasa account, and Logout. */
export function UserMenu() {
  const { user, logout } = useAuth();
  const isMobile = useIsMobile();
  const [collateralOpen, setCollateralOpen] = useState(false);
  const label = useMemo(() => (user && user.email ? user.email : '...').split('@')[0], [user]);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button
              variant="ghost"
              className="bg-background text-muted-foreground hover:bg-muted"
              {...(isMobile ? { 'aria-label': 'User menu' } : {})}
            />
          }
        >
          <CircleUserRoundIcon aria-hidden />
          {isMobile ? null : (
            <>
              <span className="max-w-[100px] truncate">{label}</span>
              <ChevronDownIcon aria-hidden className="text-muted-foreground/60" />
            </>
          )}
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-44">
          <DropdownMenuItem onClick={() => setCollateralOpen(true)}>Collateral</DropdownMenuItem>
          <DropdownMenuItem onClick={() => window.open(`${import.meta.env.VITE_KALIDASA_BASE_URI}`, '_blank')}>Account</DropdownMenuItem>
          <DropdownMenuItem onClick={() => logout()}>Logout</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <CollateralModal open={collateralOpen} onClose={() => setCollateralOpen(false)} />
    </>
  );
}
